import React, { useEffect, useRef, useState } from 'react';
// Styles live in common.scss alongside CommonDropdown's, which this control is
// styled to match. They used to be a hardcoded dark palette in this file,
// injected into <head> on first mount.
import './common.scss';

function CommonMultiSelect({ value = [], onChange, options = [], placeholder = 'Select…', disabled }) {
    const [open, setOpen] = useState(false);
    const boxRef = useRef(null);

    useEffect(() => {
        if (!open) return undefined;
        const onDocClick = (e) => {
            if (boxRef.current && !boxRef.current.contains(e.target)) setOpen(false);
        };
        document.addEventListener('mousedown', onDocClick);
        return () => document.removeEventListener('mousedown', onDocClick);
    }, [open]);

    const selected = Array.isArray(value) ? value : [];
    const toggle = (val) => {
        onChange(selected.includes(val) ? selected.filter(v => v !== val) : [...selected, val]);
    };
    const labelFor = (val) => {
        const found = options.find(o => o.value === val);
        return found ? found.label : val;
    };

    return (
        <div className={`cmn-ms${disabled ? ' cmn-ms--disabled' : ''}`} ref={boxRef}>
            <div className="cmn-ms-control" onClick={() => !disabled && setOpen(o => !o)}>
                {selected.length === 0 ? (
                    <span className="cmn-ms-placeholder">{placeholder}</span>
                ) : (
                    <div className="cmn-ms-chips">
                        {selected.map(val => (
                            <span key={val} className="cmn-ms-chip">
                                {labelFor(val)}
                                <span className="cmn-ms-chip-x"
                                    onClick={(e) => { e.stopPropagation(); toggle(val); }}>×</span>
                            </span>
                        ))}
                    </div>
                )}
                <span className={`cmn-ms-caret${open ? ' open' : ''}`}>▾</span>
            </div>
            {open && (
                <div className="cmn-ms-menu">
                    {options.length === 0 && <div className="cmn-ms-empty">No options</div>}
                    {options.map(o => (
                        <label key={o.value} className="cmn-ms-opt">
                            <input type="checkbox" checked={selected.includes(o.value)}
                                onChange={() => toggle(o.value)} />
                            <span>{o.label}</span>
                        </label>
                    ))}
                </div>
            )}
        </div>
    );
}

export default CommonMultiSelect;
